import React from 'react';

import DrawerContextProvider from '../Components/Context/DrawerContext';
import ArticleContextProvider from '../Components/Context/ArticleContext';
import NotifContextProvider from '../Components/Context/NotifContext';
import ThemeContextProvider from '../Components/Context/ThemeContext';
import ProfileContextProvider from '../Components/Context/ProfileContext';
import ArticleFeed from '../Components/Feed/ArticleFeed';

export default function Article(props) {
  return (
    <div>
      <ThemeContextProvider>
        <NotifContextProvider>
          <DrawerContextProvider>
            <ProfileContextProvider>
              <ArticleContextProvider>
                <ArticleFeed />
              </ArticleContextProvider>
            </ProfileContextProvider>
          </DrawerContextProvider>
        </NotifContextProvider>
      </ThemeContextProvider>
    </div>
  );
}
